<script>
    import { createEventDispatcher } from 'svelte';
    import InlineSpinner from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/InlineSpinner.svelte?1733898724671';
    import { cart } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/cart.js?1733898724671';

    wyvr: {
        render: 'hydrate';
        loading: 'interact';
    }

    export let sku;
    export let qty = 1;
    export let disabled = false;
    export let add_text = undefined;
    export let remove_text = undefined;

    const dispatch = createEventDispatcher();

    let state = 'idle';
    $: button_text = qty > 0 ? add_text ?? 'product.add_to_cart' : remove_text ?? 'product.remove_from_cart';

    async function add_to_cart() {
        state = 'busy';
        await cart.update_item(sku, qty);
        dispatch('click', { sku, qty });
        state = 'idle';
    }
</script>

{#if state == 'busy'}
    <button class="btn btn-add-to-cart icon-cart" {disabled} type="button"><InlineSpinner /> <slot>{window.__(button_text)}</slot></button>
{:else}
    <button class="btn btn-add-to-cart icon-cart" {disabled} type="button" on:click={add_to_cart}><slot>{window.__(button_text)}</slot></button
    >
{/if}


<style>
    

    .icon-cart:before {
        color: #040b1c;
    }
    .btn {
        background: #71c062;
        color: white;
        border: 1px solid #71c062;
        font-size: 1rem;
        font-family: 'Open Sans', Arial, Helvetica, sans-serif !important;
        width: 100%;
        display: flex;
        gap: 5px;
        height: 100%;
        transition: all 0.8s ease-in-out;
    }

    @media (min-width: 768px) {
        .btn {
            font-size: 1rem;
            padding: 15px 20px;
        }
    }
    @media (max-width: 768px) {
        .btn {
            line-height: 1.35rem !important;
        }
    }

    .btn:hover {
        color: white;
        background-color: #707070;
        border: 1px solid #71c062;
    }

    .btn::before {
        font-size: 35px;
        margin-right: 20px;
        font-family: 'kofferworld';
        color: white;
        font-weight: 400;
        display: inline-block;
    }

    @media (max-width: 768px) {
        .btn {
            font-size: 0.875rem !important;
        }
        .btn::before {
            font-size: 25px !important;
            margin-right: 10px !important;
        }
    }
</style>